import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

export function LabelTooltip({ labelStyle, label }) {
  return (
    <div className={style.labelTooltip} style={labelStyle}>
      <p>{label}</p>
    </div>
  );
}

LabelTooltip.propTypes = {
  /**
   * Style for the label
   */
  labelStyle: PropTypes.object,
  /**
   * Label to display on tooltip
   */
  label: PropTypes.string,
};

LabelTooltip.defaultProps = {
  labelStyle: {},
};
